import { useMutation } from 'react-query';

import { EindomfinansAPI } from '../api';

export const useCheckUploadedFiles = () => {
    return useMutation(EindomfinansAPI.checkUploadedFiles);
};
